'use client';

import React from 'react';
import EfWebNavList from './comps/EfWebNavList';
import SubClientList from './comps/SubClientList';

interface Props {
    prefixCls: string;
    navItems: any[];
    TextHeader: any;
    // 搜索面板
    SearchPanel?: any;
}

const NavList2: React.FC<Props> = ({ prefixCls, navItems, SearchPanel }) => {
    return (
        <EfWebNavList prefixCls={prefixCls} SearchPanel={SearchPanel}>
            {navItems.map((item, idx) => (
                <EfWebNavList.Item prefixCls={prefixCls} itemId={item.id} title={item.name} key={item.id || idx}>
                    <SubClientList prefixCls={prefixCls} item={item} itemId={item.id} title={item.name} index={idx} key={item.id || idx} />
                </EfWebNavList.Item>
            ))}
        </EfWebNavList>
    );
};

export default NavList2;
